import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M24 6a17.969 17.969 0 0 0-14.017 6.706 1.515 1.515 0 0 1-.014-.21L9.967 7a1 1 0 1 0-2 0l.002 5.496a3.5 3.5 0 0 0 3.498 3.5l5.48.004a1 1 0 1 0 .001-2l-5.436-.004A15.97 15.97 0 0 1 24 8c8.837 0 16 7.163 16 16s-7.163 16-16 16S8 32.837 8 24a1 1 0 1 0-2 0c0 9.941 8.059 18 18 18s18-8.059 18-18S33.941 6 24 6Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 23h-8c-1.333 0-1.333 2 0 2h8.994c.335 0 .61-.078.772-.229.163-.15.234-.443.234-.77V10.82c0-.419-.545-.819-1.028-.819-.484 0-.876.274-.972.819V23Z",
    fill: "currentColor"
  }));
};

var SvgHistory = styled(SvgComponent).withConfig({
  displayName: "History__SvgHistory",
  componentId: "sc-fdkjdm-0"
})(["", " ", ""], size, color);
export default SvgHistory;